var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnrealEngine5Integration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_75_649)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M162.989 25C165.745 25.7225 168.361 26.6931 170.48 28.7205C173.366 31.4866 174.978 34.8296 174.984 38.8467C175.011 54.4673 175 70.0825 174.989 85.7031C174.989 88.7065 173.058 90.5937 170.017 90.5991C165.821 90.6098 161.619 90.6152 157.423 90.5883C156.619 90.5829 156.264 90.6799 156.193 91.6613C155.686 99.016 149.554 104.661 142.181 104.661C134.82 104.661 128.677 98.9944 128.175 91.6505C128.11 90.6584 127.722 90.5829 126.934 90.5883C122.787 90.6152 118.634 90.6044 114.487 90.5991C111.256 90.5991 109.379 88.7442 109.379 85.5414C109.374 79.195 109.546 72.8432 109.314 66.5076C109.174 62.7009 113.176 59.9509 116.563 61.8813C118.375 62.9165 120.177 62.5445 121.724 61.2342C123.078 60.0911 123.725 58.6137 123.267 56.802C122.76 54.7908 121.412 53.6746 119.443 53.2163C118.381 52.9683 117.426 53.3026 116.482 53.734C112.734 55.4378 109.384 53.2918 109.379 49.1777C109.374 43.0794 109.471 36.9756 109.336 30.8773C109.271 28.0303 110.237 26.073 112.89 25L162.989 25Z",
    fill: "url(#paint0_linear_75_649)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 65.1267C25.7012 62.4739 26.6126 59.9342 28.5273 57.8583C31.3534 54.7957 34.8051 53.1295 38.9958 53.1295C52.6194 53.1188 66.2376 53.1403 79.8612 53.0918C81.0801 53.0918 81.2689 53.4962 81.2635 54.58C81.2204 62.0479 81.2365 69.5158 81.2419 76.9837C81.2419 81.4268 84.4726 83.5135 88.5338 81.7179C90.6102 80.8013 92.9239 81.362 94.3154 83.1198C95.653 84.8075 95.6476 87.1369 94.3046 88.7976C92.8862 90.5554 90.5509 91.2348 88.5284 90.0647C85.3786 88.2422 81.0586 90.4583 81.2096 94.7719C81.366 99.161 81.1988 103.556 81.2743 107.95C81.2959 109.142 80.9183 109.417 79.8019 109.373C77.6554 109.293 75.5034 109.309 73.3568 109.368C72.3483 109.395 71.8953 109.249 71.7388 108.031C70.9244 101.76 67.4781 97.565 61.3512 95.8234C53.4662 93.5857 45.1874 99.037 43.99 107.141C43.7707 108.615 42.9078 109.352 41.4012 109.352C35.9324 109.352 30.4635 109.352 24.9946 109.352V65.1267H25Z",
    fill: "url(#paint1_linear_75_649)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 118.729C33.0091 118.729 41.0129 118.745 49.022 118.729C53.2666 118.724 55.4077 115.413 53.6819 111.569C52.7057 109.39 53.2288 107.082 55.0194 105.659C56.7021 104.322 59.0375 104.333 60.6932 105.675C62.4784 107.126 62.9423 109.353 61.9229 111.612C60.2294 115.365 62.3652 118.708 66.4911 118.729C70.9837 118.751 75.4764 118.767 79.9691 118.708C80.9992 118.697 81.3012 118.977 81.2635 120.007C81.188 122.299 81.1988 124.596 81.2635 126.887C81.2851 127.804 81.0262 128.074 80.0823 128.192C73.071 129.093 68.4489 133.546 67.3702 140.313C66.2268 147.501 71.5231 154.785 78.734 155.939C80.4095 156.209 81.2473 157.178 81.2473 158.846C81.2473 163.725 81.1988 168.611 81.2797 173.49C81.3012 174.752 80.9075 174.989 79.7264 174.984C66.2484 174.941 52.7758 174.962 39.2978 174.952C32.3404 174.946 26.8661 170.557 25.2858 163.769C25.2211 163.488 25.0971 163.224 25 162.954C25 148.213 25 133.471 25 118.729Z",
    fill: "url(#paint2_linear_75_649)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.804 174.957C105.97 174.957 99.137 174.908 92.309 174.994C90.8366 175.016 90.5831 174.563 90.5993 173.21C90.6694 165.844 90.6371 158.473 90.6317 151.108C90.6317 146.676 87.3849 144.567 83.3453 146.352C81.258 147.274 78.9605 146.724 77.5636 144.966C76.226 143.284 76.226 140.955 77.5636 139.294C78.982 137.531 81.3282 136.83 83.3291 138.005C86.4033 139.817 90.8528 137.725 90.6748 133.185C90.5022 128.801 90.6694 124.401 90.6155 120.012C90.6047 119.004 90.8474 118.664 91.8991 118.702C94.1913 118.783 96.4889 118.761 98.7811 118.707C99.671 118.686 99.9784 118.896 100.108 119.867C101.03 126.963 105.442 131.508 112.351 132.613C119.459 133.751 126.816 128.305 127.873 121.128C128.107 119.525 129.058 118.724 130.726 118.724C135.704 118.724 140.682 118.745 145.66 118.707C146.577 118.702 146.906 118.907 146.906 119.899C146.868 133.756 146.922 147.614 146.857 161.466C146.825 168.648 140.52 174.827 133.315 174.946C133.169 174.946 133.023 174.946 132.878 174.946C126.19 174.946 119.508 174.946 112.82 174.946L112.804 174.957Z",
    fill: "url(#paint3_linear_75_649)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_75_649",
    x1: 142.156,
    y1: 25,
    x2: 142.156,
    y2: 104.661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_75_649",
    x1: 60.1549,
    y1: 53.0918,
    x2: 60.1549,
    y2: 109.378,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_75_649",
    x1: 53.1402,
    y1: 104.662,
    x2: 53.1402,
    y2: 174.984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_75_649",
    x1: 111.733,
    y1: 118.699,
    x2: 111.733,
    y2: 174.995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_75_649"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150,
    fill: "white",
    transform: "translate(25 25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnrealEngine5Integration);
export default __webpack_public_path__ + "static/media/Unreal_Engine_5_Integration.7ea8458b0852d7c7315c99b3b5c44a0e.svg";
export { ForwardRef as ReactComponent };